import { Component } from "react";
import PropTypes from "prop-types";
import { getMyAccountBaseUrl } from "@template/helpers/externalLinks";
import { withTranslation } from "@template/components/translation";
import withViewport from "../Viewport/withViewport";
import styles from "./index.css";
import stylesDeferred from "./deferred.css";
import { isWindowDefined } from "@src/helpers/url";
import { asosGlobalNamespace, sdkGlobalNamespace } from "@template/constants";
import Button from "@template/components/Button";
import asosWorldLogo from "../Navigation/assets/asos-world-logo.svg";
import asosWorldLogoWhite from "../Navigation/assets/asos-world-logo-white.svg";
import classnames from "classnames/bind";
import {
  addCtaRefToUrl,
  generateNavigationCtaRef
} from "@template/helpers/addCtaRefToUrl";

const cx = classnames.bind(styles);

const getLoggedOutButtonLinks = formatTranslation => {
  const identitySdk =
    isWindowDefined() &&
    window[asosGlobalNamespace] !== undefined &&
    window[asosGlobalNamespace][sdkGlobalNamespace] !== undefined &&
    window[asosGlobalNamespace][sdkGlobalNamespace].identity;

  return (
    <>
      <span className={cx(styles.welcome, styles.isNotLoggedIn)}>
        {formatTranslation("myaccountlinks_asos_greeting")}
      </span>
      <span className={styles.actions}>
        <Button
          theme="primary"
          classes={styles.action}
          data-testid="signin-link"
          role="link"
          onClick={e => {
            if (!identitySdk) {
              return;
            }
            e.preventDefault();
            identitySdk.login();
          }}
        >
          {formatTranslation("myaccountlinks_sign_in_label")}
        </Button>
        <Button
          theme="secondary"
          classes={styles.action}
          data-testid="signup-link"
          role="link"
          onClick={e => {
            if (!identitySdk) {
              return;
            }
            e.preventDefault();
            identitySdk.signUp();
          }}
        >
          {formatTranslation("myaccountlinks_sign_up_label")}
        </Button>
      </span>
    </>
  );
};

const getAsosIcons = (tierNumber, isAlist, tierName) => {
  const tierImage = `asosWorldTier${tierNumber}`;
  const logo = isAlist ? asosWorldLogoWhite : asosWorldLogo;
  return (
    <div
      className={cx(styles.logoOuter, {
        [styles.logoAlist]: isAlist
      })}
    >
      <img src={logo} className={styles.logo} alt="ASOS World Logo" />
      <span className={cx(stylesDeferred[tierImage], styles.tierId)}></span>
      <span className={styles.tierName}>{tierName}</span>
    </div>
  );
};

const renderLoyaltyGreeting = (
  tierName,
  tierNumber,
  isAlist,
  exploreMyBenefitsLink,
  firstName,
  formatTranslation
) => {
  return (
    <div
      className={classnames(
        styles.outerContainer,
        stylesDeferred.outerContainerLoyalty,
        {
          [stylesDeferred.outerContainerLoyaltyAlist]: isAlist
        }
      )}
    >
      <div className={styles.asosIcons}>
        {getAsosIcons(tierNumber, isAlist, tierName)}
      </div>
      <div className={classnames(styles.container)}>
        <span
          className={cx(styles.welcome, styles.loyaltyWelcome, {
            [styles.aListWelcome]: isAlist
          })}
        >
          {formatTranslation("myaccountlinks_greeting", { name: firstName })}
        </span>
      </div>
      <div className={styles.exploreBenefitslinkContainer}>
        <a
          href={addCtaRefToUrl(
            exploreMyBenefitsLink,
            generateNavigationCtaRef({
              label: "Explore my benefits",
              linkType: "global nav - myaccount links"
            })
          )}
          className={cx(styles.exploreBenefitslink, {
            [styles.exploreBenefitslinkAlist]: isAlist
          })}
        >
          <span>
            {formatTranslation("myaccountlinks_asosworld_benefits_button")}
          </span>
        </a>
      </div>
    </div>
  );
};

class Greeter extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    formatTranslation: PropTypes.func.isRequired,
    firstName: PropTypes.string,
    tierName: PropTypes.string,
    tierNumber: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      returnUrl: false
    };
  }

  componentDidMount() {
    this.setState({
      returnUrl: window.location.href
    });
  }

  render() {
    const { isLoggedIn, firstName, formatTranslation, tierName, tierNumber } =
      this.props;

    const exploreMyBenefitsLink = getMyAccountBaseUrl() + "/asos-world";
    const isAlist = tierNumber === 4;

    if (tierName) {
      return renderLoyaltyGreeting(
        tierName,
        tierNumber,
        isAlist,
        exploreMyBenefitsLink,
        firstName,
        formatTranslation
      );
    }
    return (
      <div className={classnames(styles.outerContainer)}>
        <div
          className={classnames(styles.container, {
            [styles.containerNotLoggedIn]: !isLoggedIn
          })}
        >
          {isLoggedIn && (
            <span
              className={cx(styles.welcome, styles.notJoinedLoyaltyWelcome)}
            >
              {formatTranslation("myaccountlinks_greeting", {
                name: firstName
              })}
            </span>
          )}
          {!isLoggedIn && getLoggedOutButtonLinks(formatTranslation)}
        </div>
      </div>
    );
  }
}

export default withViewport(withTranslation(Greeter));
